// extracted by mini-css-extract-plugin
export default {"edu-history-container":"styles_edu-history-container__BoNJg","education-history-main":"styles_education-history-main__UacW6"};